import { useSelector } from 'react-redux';
import { FlexContainer, Spinner } from '@taxdown/piccolo-web';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useFetchGetFeatureFlag, useFetchSatUserStage } from 'Containers/Datagathering/hooks';
import DgHeader from 'Containers/Datagathering/components/DgHeader';
import OneColLayout from 'Components/Layouts/OneColLayout';
import DGForm from './components/DGForm';
import * as Styled from './styles';

const DataGatheringAccessRfc = (): JSX.Element => {
  const isPreviousYears = useSelector(routeStateSelector);

  const { isLoading, data } = useFetchSatUserStage(isPreviousYears);
  const { isLoading: loading, data: featureFlag } = useFetchGetFeatureFlag();

  if (isLoading || loading) {
    return (
      <FlexContainer fullHeight fullWidth justify="center" align="center">
        <Spinner size="L" justify="center" align="center" />
      </FlexContainer>
    );
  }
  return (
    <OneColLayout>
      <FlexContainer direction="column" align="center" justify="space-between">
        <Styled.ContentContainer fullWidth direction="column" align="center" justify="center">
          <DgHeader />
          <DGForm data={data} featureFlag={featureFlag} />
        </Styled.ContentContainer>
      </FlexContainer>
    </OneColLayout>
  );
};

export default DataGatheringAccessRfc;
